import { Empty, Tooltip } from "antd";
import CompactStatisticNumber from "@components/StatTileV2/CompactStatisticNumberSuffix";
import { useSlicerVariables, useWidgetData } from "../Contexts/dashboardHooks";
import { WidgetInfoButton } from "../Info/WidgetInfoButton";
import { resolveTemplate } from "../Utils/resolveTemplate";

function StatBenchmark({ label, value, color, isAsym }: { label: string; value?: string | null; color?: string | null; isAsym?: boolean }) {
  const fontSize = isAsym ? 11 : 15;
  return (
    <div style={{ color: color ?? "inherit", marginBottom: 2, lineHeight: isAsym ? 0.9 : 1.2, fontSize }}>
      {label}: {value ?? "—"}
    </div>
  );
}

export function StatTile({ id }: { id: string }) {
  const data = useWidgetData(id);
  const slicerValues = useSlicerVariables();
  const stat = data?.type === "stat_tile" ? data.stat : undefined;
  const spec = data?.type === "stat_tile" ? data.spec : undefined;

  if (!stat) {
    return (
      <div className="stat-tile-widget stat-tile-empty">
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No metric configured" />
      </div>
    );
  }

  if (!stat.metricStat) {
    return (
      <div className="stat-tile-widget stat-tile-empty">
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data" />
      </div>
    );
  }

  const ms = stat.metricStat;
  const showBenchmarks = spec?.stat_tile_builder_misc?.showTeamPosData !== false;
  const hasTeamPos = showBenchmarks && (ms.team != null || ms.pos != null);
  const labelText = resolveTemplate(stat.label ?? "", slicerValues).resolved || ms.name;

  return (
    <div className="stat-tile-widget">
      <div className="widget-header">
        <span style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 0 }}>
          <span style={{ fontSize: 18, fontWeight: 600, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {labelText}
          </span>
          <WidgetInfoButton id={id} />
        </span>
      </div>
      <div className="stat-tile-content">
        <div className="stat-tile-number-row">
          <CompactStatisticNumber
            metricStat={ms}
            isAsym={ms.is_asym}
            show_delta={true}
            dynamicFontSizing={true}
          />
        </div>
        {hasTeamPos && (
          <Tooltip title={<span>T: Team Average<br />P: Positional Average</span>}>
            <div className="stat-tile-benchmarks">
              <StatBenchmark label="T" value={ms.team?.value} color={ms.team?.color} isAsym={ms.is_asym} />
              <StatBenchmark label="P" value={ms.pos?.value} color={ms.pos?.color} isAsym={ms.is_asym} />
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
}
